import styled from 'styled-components';

export default styled.div`
    .system-item {
        &:first-of-type {
            margin-top: 0.4rem;
        }
    }
`;
